import { I18nProvider, Refine } from '@refinedev/core';
import { DevtoolsPanel, DevtoolsProvider } from '@refinedev/devtools';
import { RefineKbar, RefineKbarProvider } from '@refinedev/kbar';
import { useNotificationProvider } from '@refinedev/antd';
import '@refinedev/antd/dist/reset.css';
import routerBindings, {
  DocumentTitleHandler,
  UnsavedChangesNotifier,
} from '@refinedev/react-router-v6';
import { App as AntdApp } from 'antd';
import { BrowserRouter } from 'react-router-dom';
import { authProvider } from './authProvider';
import { ColorModeContextProvider } from './contexts/color-mode';
import { resources } from './configResources/resources';
import Stack from './configResources';
import { customTitleHandler } from './Helpers';
import { useEffect } from 'react';
import { CreateDeviceAction, axiosInstance } from './Actions/AuthActions';
import { dataProvider } from './rest-data-provider';
import { API_URL } from './configs';
import { AxiosInstance } from 'axios';
import './index.css';
import './i18n';
import { useTranslation } from 'react-i18next';
import useLangStore from './core/lang';
function App() {
  useEffect(() => {
    CreateDeviceAction();
  }, []);
  const { t, i18n } = useTranslation();
  const { setLocale, locale } = useLangStore();
  const i18nProvider: I18nProvider = {
    translate: (key: string, params: object) => {
      // @ts-ignore
      return t(key, params);
    },
    changeLocale: (lang: string) => {
      i18n.changeLanguage(lang);
      setLocale(lang);
      localStorage.setItem('direction', lang === 'ar' ? 'rtl' : 'ltr');
      localStorage.setItem('lang', lang);
    },
    getLocale: () => i18n.language,
  };
  useEffect(() => {
    if (locale) {
      i18n.changeLanguage(locale);
    }
  }, [locale, i18n]);
  useEffect(() => {
    const direction = localStorage.getItem('direction');
    if (direction) {
      document.documentElement.dir = direction;
    } else {
      document.documentElement.dir = 'ltr';
    }
  }, []);
  return (
    <BrowserRouter>
      <RefineKbarProvider>
        <ColorModeContextProvider>
          <AntdApp>
            <DevtoolsProvider>
              <Refine
                i18nProvider={i18nProvider}
                dataProvider={dataProvider(
                  API_URL,
                  axiosInstance as AxiosInstance
                )}
                notificationProvider={useNotificationProvider}
                routerProvider={routerBindings}
                authProvider={authProvider}
                resources={resources}
                options={{
                  syncWithLocation: true,
                  warnWhenUnsavedChanges: true,
                  useNewQueryKeys: true,
                  projectId: '6TmoFM-Hcvz8Z-tsFYpL',
                }}
              >
                <Stack />
                <RefineKbar />
                <UnsavedChangesNotifier />
                <DocumentTitleHandler handler={customTitleHandler} />
              </Refine>
              <DevtoolsPanel />
            </DevtoolsProvider>
          </AntdApp>
        </ColorModeContextProvider>
      </RefineKbarProvider>
    </BrowserRouter>
  );
}

export default App;
